export default class ScrollLocker {
  public static lock() {
    // スクロールバーを非表示にすることでスクロールを無効化する。
    // スクロールバーがなくなることでレイアウトがずれる問題を隠蔽する
    // 表示領域とWindowサイズの差を出して縦方向スクロールバーの横幅を出している。
    const scrollBarWidth = window.innerWidth - document.body.clientWidth;
    document.body.style.marginRight = scrollBarWidth + "px";
    document.body.style.overflowY = "hidden";
  }

  public static unlock() {
    document.body.style.marginRight = "0px";
    document.body.style.overflowY = "auto";
  }
}
